import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { RadioOrSelectOption, RootState } from '../../../../types/common.types';
import { Member } from '../../../../types/entity.types';

import { useApprovalApi } from '../../../../api/approval/useApprovalApi';
import { useMemberApi } from '../../../../api/member/useMemberApi';

import SupportChatNew from '../../../../components/screens/programme/support/support-chat-new/SupportChatNew';

const SupportChatNewContainer = () => {
  const { members } = useSelector(({ member }: RootState) => member);
  const { user } = useSelector(({ system }: RootState) => system);

  const navigate = useNavigate();

  const { status, programmeExternalReference } = useParams();

  const [searchParams] = useSearchParams();

  const { viewAllMembers } = useMemberApi();

  const { evaluateSupportConversation } = useApprovalApi();

  useEffect(() => {
    if (!programmeExternalReference) return;

    viewAllMembers({ programmeExternalReference });
  }, [programmeExternalReference, viewAllMembers]);

  const hasSubProgrammes = searchParams.get('hasSubProgrammes') === 'true';

  const navigateBack = () => {
    navigate(`/programmes/${status}/${programmeExternalReference}/support?hasSubProgrammes=${hasSubProgrammes}`);
  };

  const loadSupportChat = (member: RadioOrSelectOption<Member>) => {
    const systemUserExternalReference = member.systemUserExternalReference!;

    evaluateSupportConversation(
      {
        programmeExternalReference: programmeExternalReference!,
        systemUserExternalReference
      },
      () =>
        navigate(
          `/programmes/${status}/${programmeExternalReference}/support/${systemUserExternalReference}?hasSubProgrammes=${hasSubProgrammes}`
        )
    );
  };

  return (
    <SupportChatNew
      status={status!}
      members={members}
      username={user?.username}
      navigateBack={navigateBack}
      loadSupportChat={loadSupportChat}
    />
  );
};

export default SupportChatNewContainer;
